// extracted by mini-css-extract-plugin
export default {"filter":"OrgListContent_filter__Zy5Qr"};